(() => {
  const selector = '[data-dm-force-navigation]';
  const namespace = '.dmSliderNavigation';
  let homeArrowAlignmentFrame;
  let resizeFrame;

  const isEnabled = (value) => value === true || value === 'true';

  const clearAlignedArrowPosition = (arrow) => {
    if (!arrow) return;

    ['left', 'right', 'top'].forEach((property) => {
      arrow.style.removeProperty(property);
    });
  };

  const setAlignedArrowPosition = (arrow, positions) => {
    if (!arrow) return;

    Object.entries(positions).forEach(([property, value]) => {
      arrow.style.setProperty(property, `${value}px`, 'important');
    });
  };

  const alignProductSliderArrows = (slider) => {
    const previous = slider.querySelector(':scope > .dm-slider-nav-arrow--prev');
    const next = slider.querySelector(':scope > .dm-slider-nav-arrow--next');

    if (!previous || !next) return;

    const usesHomeCardNavigation = document.body.classList.contains('template-index')
      || Boolean(slider.closest('.dm-home-product-cards'));

    if (!usesHomeCardNavigation || window.innerWidth < 768) {
      clearAlignedArrowPosition(previous);
      clearAlignedArrowPosition(next);
      return;
    }

    const sliderRect = slider.getBoundingClientRect();
    const tolerance = 1;
    const cards = Array.from(
      slider.querySelectorAll(':scope > .slick-list .slick-slide.slick-active .product-item')
    ).filter((card) => {
      const cardRect = card.getBoundingClientRect();
      return cardRect.width > 0
        && cardRect.height > 0
        && cardRect.left >= sliderRect.left - tolerance
        && cardRect.right <= sliderRect.right + tolerance;
    });

    if (!cards.length) return;

    const cardRects = cards.map((card) => card.getBoundingClientRect());
    const firstCard = cardRects.reduce((first, cardRect) => (
      cardRect.left < first.left ? cardRect : first
    ));
    const lastCard = cardRects.reduce((last, cardRect) => (
      cardRect.right > last.right ? cardRect : last
    ));
    setAlignedArrowPosition(previous, {
      top: ((firstCard.top + firstCard.bottom) / 2) - sliderRect.top
    });
    previous.style.removeProperty('left');
    previous.style.removeProperty('right');

    setAlignedArrowPosition(next, {
      top: ((lastCard.top + lastCard.bottom) / 2) - sliderRect.top
    });
    next.style.removeProperty('right');
    next.style.removeProperty('left');
  };

  const alignVideoGalleryArrows = (gallery) => {
    const navigationRoot = gallery.parentElement;
    const previous = navigationRoot?.querySelector(':scope > .video-gallery-prev');
    const next = navigationRoot?.querySelector(':scope > .video-gallery-next');

    if (!previous || !next) return;

    if (!document.body.classList.contains('template-index') || window.innerWidth < 768) {
      clearAlignedArrowPosition(previous);
      clearAlignedArrowPosition(next);
      return;
    }

    const galleryRect = gallery.getBoundingClientRect();
    const tolerance = 1;
    const visibleCards = Array.from(gallery.querySelectorAll('video-gallery-element.swiper-slide'))
      .map((card) => card.getBoundingClientRect())
      .filter((cardRect) => (
        cardRect.width > 0
        && cardRect.height > 0
        && cardRect.left >= galleryRect.left - tolerance
        && cardRect.right <= galleryRect.right + tolerance
      ));

    if (!visibleCards.length) return;

    const firstCard = visibleCards.reduce((first, cardRect) => (
      cardRect.left < first.left ? cardRect : first
    ));
    const lastCard = visibleCards.reduce((last, cardRect) => (
      cardRect.right > last.right ? cardRect : last
    ));
    setAlignedArrowPosition(previous, {
      top: ((firstCard.top + firstCard.bottom) / 2) - galleryRect.top
    });
    previous.style.removeProperty('left');
    previous.style.removeProperty('right');

    setAlignedArrowPosition(next, {
      top: ((lastCard.top + lastCard.bottom) / 2) - galleryRect.top
    });
    next.style.removeProperty('right');
    next.style.removeProperty('left');
  };

  const alignHomeArrows = () => {
    const productSliders = Array.from(document.querySelectorAll(selector));
    productSliders.forEach(alignProductSliderArrows);

    document.querySelectorAll('.video-gallery-section .video-gallery').forEach((gallery) => {
      alignVideoGalleryArrows(gallery);
    });
  };

  const scheduleHomeArrowAlignment = () => {
    cancelAnimationFrame(homeArrowAlignmentFrame);
    homeArrowAlignmentFrame = requestAnimationFrame(() => {
      requestAnimationFrame(alignHomeArrows);
    });
  };

  const getSlick = (slider) => {
    if (slider.slick) return slider.slick;
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return null;

    try {
      return window.jQuery(slider).slick('getSlick');
    } catch (error) {
      return null;
    }
  };

  const getNavigationMetrics = (slick) => {
    const slidesToShow = Math.max(1, Math.ceil(Number(slick.options.slidesToShow) || 1));
    const slidesToScroll = Math.max(1, Number(slick.options.slidesToScroll) || 1);
    const lastStart = Math.max(0, slick.slideCount - slidesToShow);
    const positions = [0];

    for (let position = slidesToScroll; position < lastStart; position += slidesToScroll) {
      positions.push(position);
    }
    if (positions[positions.length - 1] !== lastStart) positions.push(lastStart);

    return { lastStart, positions };
  };

  const normalizePosition = (slider) => {
    const slick = getSlick(slider);
    if (!slick) return false;

    const currentSlide = Math.max(0, Number(slick.currentSlide) || 0);
    const { lastStart } = getNavigationMetrics(slick);
    if (currentSlide <= lastStart) return false;

    slick.slideHandler(lastStart, false, true);
    return true;
  };

  const removeLegacyArrows = (slider) => {
    /* Em reinicializações responsivas, o Slick pode puxar um controle DM para
       dentro da faixa de slides. Esse nó deixa de ser um controle válido e é
       removido do DOM antes que uma nova navegação seja montada. */
    slider.querySelectorAll('.dm-slider-nav-arrow').forEach((arrow) => {
      if (arrow.parentElement !== slider) arrow.remove();
    });

    slider.querySelectorAll([
      ':scope > .slick-arrow',
      ':scope > .slick-prev',
      ':scope > .slick-next',
      '.product-item .slick-arrow',
      '.product-item .slick-prev',
      '.product-item .slick-next',
      '.card-product .slick-arrow',
      '.card-product .slick-prev',
      '.card-product .slick-next',
      '.card-media .slick-arrow',
      '.card-media .slick-prev',
      '.card-media .slick-next'
    ].join(',')).forEach((arrow) => arrow.remove());
  };

  const createButton = (slider, direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `dm-slider-nav-arrow dm-slider-nav-arrow--${direction}`;
    if (direction === 'prev') {
      const keepPreviousVisible = slider.hasAttribute('data-dm-keep-prev-visible');
      button.hidden = !keepPreviousVisible;
      button.disabled = !keepPreviousVisible;
      button.setAttribute('aria-hidden', button.hidden ? 'true' : 'false');
    }
    button.setAttribute(
      'aria-label',
      direction === 'prev' ? 'Conteúdo anterior' : 'Próximo conteúdo'
    );
    button.innerHTML = [
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<path d="M9 4.5 16.5 12 9 19.5"></path>',
      '</svg>'
    ].join('');
    button.addEventListener('click', () => {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

      const carousel = window.jQuery(slider);
      if (!carousel.hasClass('slick-initialized')) return;

      const slick = getSlick(slider);
      if (!slick) return;

      const currentSlide = Math.max(0, Number(slick.currentSlide) || 0);
      const { positions } = getNavigationMetrics(slick);
      const target = direction === 'prev'
        ? positions.slice().reverse().find((position) => position < currentSlide) ?? 0
        : positions.find((position) => position > currentSlide) ?? positions[positions.length - 1];

      /* slickGoTo passa o índice por checkNavigable e, quando o total não é
         múltiplo do grupo, arredonda para um início que deixa colunas vazias.
         slideHandler mantém o início exato calculado para o último conjunto. */
      if (target !== currentSlide) slick.slideHandler(target);
    });
    return button;
  };

  const updateArrows = (slider) => {
    const slick = getSlick(slider);
    const previous = slider.querySelector(':scope > .dm-slider-nav-arrow--prev');
    const next = slider.querySelector(':scope > .dm-slider-nav-arrow--next');
    if (!slick || !previous || !next) return;

    const currentSlide = Math.max(0, Number(slick.currentSlide) || 0);
    const { lastStart } = getNavigationMetrics(slick);
    const isAtStart = currentSlide <= 0;
    const isAtEnd = currentSlide >= lastStart;
    const keepPreviousVisible = slider.hasAttribute('data-dm-keep-prev-visible');
    previous.hidden = isAtStart && !keepPreviousVisible;
    previous.disabled = isAtStart;
    previous.setAttribute('aria-hidden', previous.hidden ? 'true' : 'false');
    previous.tabIndex = isAtStart ? -1 : 0;
    next.hidden = false;
    next.disabled = isAtEnd;
    next.setAttribute('aria-hidden', 'false');
    next.tabIndex = isAtEnd ? -1 : 0;
    scheduleHomeArrowAlignment();
  };

  const getAdjacentDots = (slider) => {
    const dots = [];
    let sibling = slider.nextElementSibling;

    while (sibling?.classList.contains('dm-slider-nav-dots')) {
      dots.push(sibling);
      sibling = sibling.nextElementSibling;
    }

    return dots;
  };

  const getDots = (slider) => {
    if (slider.dmSliderNavigationDots?.isConnected) return slider.dmSliderNavigationDots;

    const legacyDots = slider.querySelector(':scope > .dm-slider-nav-dots')
      || getAdjacentDots(slider)[0];
    if (legacyDots) slider.dmSliderNavigationDots = legacyDots;
    return legacyDots;
  };

  const removeDots = (slider) => {
    const customDots = new Set([
      slider.dmSliderNavigationDots,
      ...slider.querySelectorAll('.dm-slider-nav-dots'),
      ...getAdjacentDots(slider)
    ]);

    customDots.forEach((dots) => dots?.remove());
    delete slider.dmSliderNavigationDots;
  };

  const removeNativeDots = (slider) => {
    slider.querySelectorAll(':scope > .slick-dots').forEach((dots) => dots.remove());
  };

  const updateDots = (slider) => {
    const slick = getSlick(slider);
    const dots = getDots(slider);
    if (!slick || !dots) return;

    const { positions } = getNavigationMetrics(slick);
    const currentSlide = Math.max(0, Number(slick.currentSlide) || 0);
    const currentDot = positions.reduce((closest, position, index) => (
      Math.abs(position - currentSlide) < Math.abs(positions[closest] - currentSlide)
        ? index
        : closest
    ), 0);

    Array.from(dots.children).forEach((item, index) => {
      const active = index === currentDot;
      item.classList.toggle('is-active', active);
      item.querySelector('button')?.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  const createDots = (slider) => {
    const slick = getSlick(slider);
    if (!slick) return null;

    const dots = document.createElement('ul');
    dots.className = 'dm-slider-nav-dots';
    dots.setAttribute('aria-label', 'Navegação do carrossel');

    const { positions } = getNavigationMetrics(slick);

    positions.forEach((position, index) => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Ir para o grupo ${index + 1}`);
      button.addEventListener('click', () => {
        if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
        slick.slideHandler(position);
      });
      item.append(button);
      dots.append(item);
    });

    return dots;
  };

  const rebuildDots = (slider) => {
    removeDots(slider);

    const useMobileSetting = window.matchMedia('(max-width: 1024px)').matches;
    const dotsEnabled = isEnabled(
      useMobileSetting ? slider.dataset.itemDotsMb : slider.dataset.itemDots
    );

    if (!dotsEnabled) return;

    const dots = createDots(slider);
    if (dots) {
      /*
       * Os dots não podem ser filhos diretos do carrossel. Em breakpoints e
       * reInit o Slick reprocessa os filhos diretos e transformava esta lista
       * em um slide, deslocando os produtos e criando áreas vazias.
       */
      slider.insertAdjacentElement('afterend', dots);
      slider.dmSliderNavigationDots = dots;
      updateDots(slider);
    }
  };

  const mount = (slider) => {
    if (window.matchMedia('(max-width: 767px)').matches && slider.hasAttribute('data-dm-mobile-snap')) {
      slider.querySelectorAll(':scope > .dm-slider-nav-arrow').forEach((control) => control.remove());
      removeDots(slider);
      slider.classList.remove('dm-slider-navigation-mounted');
      return;
    }

    if (!slider.classList.contains('slick-initialized')) return;

    /* A navegação desta vitrine é inteiramente controlada pelos botões dm.
       Remover os botões nativos do Slick evita que o SVG interno sobreviva
       isolado dentro do card após breakpoints/reinicializações no editor. */
    removeLegacyArrows(slider);
    removeNativeDots(slider);

    if (!slider.querySelector(':scope > .dm-slider-nav-arrow')) {
      slider.append(
        createButton(slider, 'prev'),
        createButton(slider, 'next')
      );
    }

    slider.classList.add('dm-slider-navigation-mounted');

    if (!getDots(slider)) {
      rebuildDots(slider);
    }

    if (window.jQuery && !slider.dataset.dmNavigationEvents) {
      window.jQuery(slider)
        .off(namespace)
        .on(`afterChange${namespace}`, () => {
          if (normalizePosition(slider)) return;
          updateDots(slider);
          updateArrows(slider);
        })
        .on(`reInit${namespace} breakpoint${namespace}`, () => {
          removeLegacyArrows(slider);
          removeNativeDots(slider);
          // O Slick pode mover as setas DM para os slides durante o refresh.
          // Remonta a navegacao depois da limpeza; mount tambem protege mobile/unslick.
          requestAnimationFrame(() => mount(slider));
          rebuildDots(slider);
          updateDots(slider);
          updateArrows(slider);
        });
      slider.dataset.dmNavigationEvents = 'true';
    }

    if (normalizePosition(slider)) return;
    updateDots(slider);
    updateArrows(slider);
  };

  const refresh = (root = document) => {
    if (root && root.matches && root.matches(selector)) mount(root);
    if (root && root.querySelectorAll) root.querySelectorAll(selector).forEach(mount);
  };

  if (window.dmSliderNavigation) {
    window.dmSliderNavigation.refresh();
    return;
  }

  window.dmSliderNavigation = { refresh, alignHomeArrows: scheduleHomeArrowAlignment };

  const start = () => {
    refresh();
    scheduleHomeArrowAlignment();

    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(document)
        .off(`init${namespace}`, selector)
        .on(`init${namespace}`, selector, function () {
          mount(this);
        });
    }

    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        document.querySelectorAll(selector).forEach((slider) => {
          if (slider.classList.contains('slick-initialized')) rebuildDots(slider);
        });
        scheduleHomeArrowAlignment();
      });
    });

    window.addEventListener('load', scheduleHomeArrowAlignment);
    document.addEventListener('shopify:section:load', scheduleHomeArrowAlignment);
    document.addEventListener('shopify:section:select', scheduleHomeArrowAlignment);
    document.addEventListener('transitionend', (event) => {
      if (event.target.closest?.('.video-gallery')) scheduleHomeArrowAlignment();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    refresh(event.target);
  });
})();
